import { render, staticRenderFns } from "./desktopDeclination2.vue?vue&type=template&id=5a0b80f2&scoped=true&"
import script from "./desktopDeclination2.vue?vue&type=script&lang=ts&"
export * from "./desktopDeclination2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0b80f2",
  null
  
)

export default component.exports